// // import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
// // import { createPortal } from "react-dom";
// // import { useFormikContext } from "formik";
// // import {
// //   UserRoundCog,
// //   UsersRound,
// //   Info,
// //   ShieldCheck,
// //   Clock,
// //   ChevronRight,
// // } from "lucide-react";

// // /* ------------------ utils ------------------ */
// // const titleCase = (s = "") => {
// //   if (s && typeof s === "object") s = s.label || s.value || "";
// //   if (typeof s !== "string") return "";
// //   return s
// //     .replace(/[_-]+/g, " ")
// //     .split(" ")
// //     .filter(Boolean)
// //     .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
// //     .join(" ");
// // };

// // const stageTitle = (idx) => `Stage ${idx + 1}`;

// // const timelineLabelMap = {
// //   lt_3_days: "< 3 Days",
// //   within_week: "< 7 Days",
// //   within_10_days: "< 10 Days",
// // };

// // const getTimelineLabel = (v) => {
// //   if (!v) return "—";
// //   if (typeof v === "object") v = v.label || v.value;
// //   return timelineLabelMap[v] || titleCase(v);
// // };

// // const actionNames = {
// //   approve: "Approve",
// //   reject: "Reject",
// //   rollback: "Rollback",
// //   edit: "Edit",
// // };

// // const actionsToList = (a = {}) =>
// //   Object.entries(a)
// //     .filter(([_, on]) => !!on)
// //     .map(([k]) => actionNames[k]);

// // const usersToNames = (users) =>
// //   (users && users.length
// //     ? users.map((u) => titleCase(u))
// //     : ["—"]
// //   ).join(", ");

// // const getRoleLabel = (role) => {
// //   if (!role) return "—";
// //   if (typeof role === "object") return role.label || titleCase(role.value);
// //   return titleCase(role);
// // };

// // const originatorDisplay = (o) => {
// //   if (!o) return { title: "Originator", subtitle: "—" };
// //   const dept = titleCase(o.departmentObj.label);
// //   const role = titleCase(o.roleObj.label);
// //   const subtitle = [dept, role].filter(Boolean).join(" / ");
// //   return { title: "Originator", subtitle: subtitle || "Originator" };
// // };

// // const Connector = () => (
// //   <div
// //     className="mx-2 flex-1 h-[1px] border border-[var(--button-border-color)] min-w-10"
// //     aria-hidden
// //   />
// // );

// // const Pill = ({ children, className }) => (
// //   <span
// //     className={
// //       "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium " +
// //       (className || "bg-slate-100 text-slate-700")
// //     }
// //   >
// //     {children}
// //   </span>
// // );

// // /* ------------------ Safe Tooltip (Portal + clamp) ------------------ */
// // function TooltipPortal({ anchorRect, open, children, offset = 10, margin = 12 }) {
// //   const tooltipRef = useRef(null);
// //   const [style, setStyle] = useState({ display: "none" });

// //   const recompute = () => {
// //     if (!open || !anchorRect || !tooltipRef.current) {
// //       setStyle({ display: "none" });
// //       return;
// //     }

// //     const vw = window.innerWidth;
// //     const tw = tooltipRef.current.offsetWidth;

// //     const top = Math.max(0, anchorRect.bottom + offset);
// //     const anchorCenterX = anchorRect.left + anchorRect.width / 2;

// //     const clampedLeft = Math.min(
// //       Math.max(anchorCenterX - tw / 2, margin),
// //       Math.max(margin, vw - margin - tw)
// //     );

// //     setStyle({
// //       position: "fixed",
// //       top,
// //       left: clampedLeft,
// //       zIndex: 9999,
// //       display: "block",
// //       maxWidth: `min(${vw - margin * 2}px, 420px)`,
// //     });
// //   };

// //   useLayoutEffect(() => {
// //     recompute();
// //   }, [open, anchorRect]);

// //   useEffect(() => {
// //     if (!open) return;
// //     const onScroll = () => recompute();
// //     const onResize = () => recompute();
// //     window.addEventListener("scroll", onScroll, true);
// //     window.addEventListener("resize", onResize);
// //     const id = requestAnimationFrame(recompute);
// //     return () => {
// //       cancelAnimationFrame(id);
// //       window.removeEventListener("scroll", onScroll, true);
// //       window.removeEventListener("resize", onResize);
// //       cancelAnimationFrame(id);
// //     };
// //   }, [open, anchorRect]);

// //   if (!open) return null;

// //   return createPortal(
// //     <div ref={tooltipRef} style={style} className="pointer-events-none">
// //       <div className="relative">
// //         <div className="rounded-xl bg-[var(--background-grey)] p-4 text-white shadow-2xl ring-1 ring-black/10">
// //           {children}
// //         </div>
// //       </div>
// //     </div>,
// //     document.body
// //   );
// // }

// // /* ------------------ Stage Node ------------------ */
// // const StageNode = ({ title, subtitle, tooltip, variant = "approver" }) => {
// //   const isOriginator = variant === "originator";
// //   const isSkipped = variant === "skipped";

// //   const anchorRef = useRef(null);
// //   const [open, setOpen] = useState(false);
// //   const [rect, setRect] = useState(null);

// //   const updateRect = () => {
// //     if (anchorRef.current) {
// //       setRect(anchorRef.current.getBoundingClientRect());
// //     }
// //   };

// //   return (
// //     <div
// //       ref={anchorRef}
// //       className="relative"
// //       onMouseEnter={() => {
// //         updateRect();
// //         setOpen(true);
// //       }}
// //       onMouseLeave={() => setOpen(false)}
// //       onMouseMove={() => updateRect()}
// //     >
// //       <div
// //         className={
// //           "w-40 rounded-2xl border p-3 text-center shadow-sm transition " +
// //           (isOriginator
// //             ? "bg-white border-[var(--button-border-color)]"
// //             : isSkipped
// //             ? "bg-slate-50 border-[var(--button-border-color)] opacity-60"
// //             : "bg-white border-[var(--button-border-color)]")
// //         }
// //       >
// //         <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--background-grey)] text-white shadow">
// //           {isOriginator ? <UserRoundCog size={30} /> : <UsersRound size={30} />}
// //         </div>
// //         <div className="text-[13px] font-semibold text-slate-900">{title}</div>
// //         <div className="mt-0.5 text-[11px] text-slate-500">{subtitle || "—"}</div>
// //       </div>

// //       {tooltip ? (
// //         <TooltipPortal anchorRect={rect} open={open}>
// //           <div className="space-y-1 text-sm">{tooltip}</div>
// //         </TooltipPortal>
// //       ) : null}
// //     </div>
// //   );
// // };

// // /* ------------------ main preview ------------------ */
// // export function FlowPreviewRender({ data }) {
// //   const originator = data.originators?.[0];
// //   const { title, subtitle } = originatorDisplay(originator);

// //   const stages = data.approvalStages || [];
// //   const isAutoApprovedWhenNoStages = stages.length === 0;

// //   return (
// //     <div className="w-full rounded-2xl border border-[var(--button-border-color)] shadow-sm p-5">
// //       <div className="mb-4 flex items-center justify-between">
// //         <div>
// //           <h2 className="text-lg font-semibold text-slate-900">
// //             {titleCase(data.flow_name || "Approval Flow Preview")}
// //           </h2>
// //           <p className="text-sm text-[var(--description-color)] mt-2">
// //             {titleCase(data.documentCategory || "")} / {titleCase(data.documentType || "")}
// //           </p>
// //         </div>
// //         <Pill className={data.is_active ? "text-[var(--success-color)]" : "text-[var(--error-color)]"}>
// //           <ShieldCheck size={15} /> {data.is_active ? "Active" : "Inactive"}
// //         </Pill>
// //       </div>

// //       <div className="flex items-center max-w-full overflow-x-auto">
// //         <StageNode title={title} subtitle={subtitle} variant="originator" />
// //         {stages.map((s, i) => (
// //           <React.Fragment key={i}>
// //             <Connector />
// //             <StageNode
// //               title={stageTitle(i)}
// //               subtitle={getRoleLabel(s.role_name)}
// //               tooltip={
// //                 <>
// //                   <div className="flex items-start gap-2">
// //                     <div>
// //                       <span className="font-semibold opacity-60">Role:</span> {s.role_name}
// //                     </div>
// //                   </div>
// //                   <div className="flex items-start gap-2">
// //                     <div>
// //                       <span className="font-semibold opacity-60">Users:</span> {usersToNames(s.users)}
// //                     </div>
// //                   </div>
// //                   <div className="flex items-start gap-2">
// //                     <div>
// //                       <span className="font-semibold opacity-60">Timeline:</span> {getTimelineLabel(s.timeline)}
// //                     </div>
// //                   </div>
// //                   <div className="flex items-start gap-2">
// //                     <div>
// //                       <span className="font-semibold opacity-60">Actions:</span>{" "}
// //                       {actionsToList(s.actions).join(", ") || "—"}
// //                     </div>
// //                   </div>
// //                 </>
// //               }
// //             />
// //           </React.Fragment>
// //         ))}
// //       </div>

// //       <div className="mt-4 rounded-xl border border-[#E5E7EB] bg-[#E5E7EB] p-5 text-sm text-slate-700">
// //         <div className="flex items-start gap-2">
// //           <Info className="mt-0.5" size={20} fill="#374151" stroke="#fff" />
// //           <div>
// //             <div className="font-medium text-[#1F2937]">Auto-Approval Notice</div>
// //             <div className="text-[#374151]">
// //               {isAutoApprovedWhenNoStages
// //                 ? "Auto-approved when originator is the last stage."
// //                 : "Auto-approved when originator is last stage and no pending approval remains."}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="mt-6">
// //         <div className="text-sm font-medium text-slate-700 mb-2">Legend</div>
// //         <div className="flex flex-wrap items-center gap-6 text-sm">
// //           <div className="flex items-center gap-2">
// //             <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--background-grey)] text-white">
// //               <UserRoundCog size={14} />
// //             </span>{" "}
// //             Originator
// //           </div>
// //           <div className="flex items-center gap-2">
// //             <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--background-grey)] text-white">
// //               <UsersRound size={14} />
// //             </span>{" "}
// //             Approver
// //           </div>
// //           <div className="flex items-center gap-2">
// //             <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--background-grey)] text-white opacity-60">
// //               <UsersRound size={14} />
// //             </span>{" "}
// //             Skipped Stage
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default function FlowPreview() {
// //   const { values } = useFormikContext();
// //   return (
// //     <div className="max-w-full overflow-auto w-full">
// //       <FlowPreviewRender data={values} />
// //     </div>
// //   );
// // }

// import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
// import { createPortal } from "react-dom";
// import { useFormikContext } from "formik";
// import {
//   UserRoundCog,
//   UsersRound,
//   Info,
//   ShieldCheck,
// } from "lucide-react";

// /* ------------------ utils ------------------ */
// const titleCase = (s = "") => {
//   if (s && typeof s === "object") s = s.label || s.value || "";
//   if (typeof s !== "string") return "";
//   return s
//     .replace(/[_-]+/g, " ")
//     .split(" ")
//     .filter(Boolean)
//     .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
//     .join(" ");
// };

// const stageTitle = (idx) => `Stage ${idx + 1}`;

// const timelineLabelMap = {
//   lt_3_days: "< 3 Days",
//   within_week: "< 7 Days",
//   within_10_days: "< 10 Days",
// };

// const getTimelineLabel = (v) => {
//   if (!v) return "—";
//   if (typeof v === "object") v = v.label || v.value;
//   return timelineLabelMap[v] || titleCase(v);
// };

// const actionNames = {
//   approve: "Approve",
//   reject: "Reject",
//   rollback: "Rollback",
//   edit: "Edit",
// };

// const actionsToList = (a = {}) =>
//   Object.entries(a)
//     .filter(([_, on]) => !!on)
//     .map(([k]) => actionNames[k]);

// const usersToNames = (users) =>
//   (users && users.length ? users.map((u) => titleCase(u)).join(", ") : "—");

// const getRoleLabel = (role) => {
//   if (!role) return "—";
//   if (typeof role === "object") return role.label || titleCase(role.value);
//   return titleCase(role);
// };

// const originatorDisplay = (o) => {
//   if (!o) return { title: "Originator", subtitle: "—" };
//   const dept = titleCase(o.departmentObj?.label);
//   const role = titleCase(o.roleObj?.label);
//   const subtitle = [dept, role].filter(Boolean).join(" / ");
//   return { title: "Originator", subtitle: subtitle || "Originator" };
// };

// const Connector = () => (
//   <div
//     className="mx-2 flex-1 h-[1px] border border-[var(--button-border-color)] min-w-10"
//     aria-hidden
//   />
// );

// const Pill = ({ children, className }) => (
//   <span
//     className={
//       "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium " +
//       (className || "bg-slate-100 text-slate-700")
//     }
//   >
//     {children}
//   </span>
// );

// /* ------------------ Safe Tooltip ------------------ */
// function TooltipPortal({ anchorRect, open, children, offset = 10, margin = 12 }) {
//   const tooltipRef = useRef(null);
//   const [style, setStyle] = useState({ display: "none" });

//   const recompute = () => {
//     if (!open || !anchorRect || !tooltipRef.current) {
//       setStyle({ display: "none" });
//       return;
//     }

//     const vw = window.innerWidth;
//     const tw = tooltipRef.current.offsetWidth;
//     const top = Math.max(0, anchorRect.bottom + offset);
//     const anchorCenterX = anchorRect.left + anchorRect.width / 2;

//     const clampedLeft = Math.min(
//       Math.max(anchorCenterX - tw / 2, margin),
//       Math.max(margin, vw - margin - tw)
//     );

//     setStyle({
//       position: "fixed",
//       top,
//       left: clampedLeft,
//       zIndex: 9999,
//       display: "block",
//       maxWidth: `min(${vw - margin * 2}px, 420px)`,
//     });
//   };

//   useLayoutEffect(() => {
//     recompute();
//   }, [open, anchorRect]);

//   useEffect(() => {
//     if (!open) return;
//     const onScroll = () => recompute();
//     const onResize = () => recompute();
//     window.addEventListener("scroll", onScroll, true);
//     window.addEventListener("resize", onResize);
//     const id = requestAnimationFrame(recompute);
//     return () => {
//       cancelAnimationFrame(id);
//       window.removeEventListener("scroll", onScroll, true);
//       window.removeEventListener("resize", onResize);
//       cancelAnimationFrame(id);
//     };
//   }, [open, anchorRect]);

//   if (!open) return null;

//   return createPortal(
//     <div ref={tooltipRef} style={style} className="pointer-events-none">
//       <div className="relative">
//         <div className="rounded-xl bg-[var(--background-grey)] p-4 text-white shadow-2xl ring-1 ring-black/10">
//           {children}
//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// }

// /* ------------------ Stage Node ------------------ */
// const StageNode = ({ title, subtitle, tooltip, variant = "approver" }) => {
//   const isOriginator = variant === "originator";
//   const isSkipped = variant === "skipped";
//   const anchorRef = useRef(null);
//   const [open, setOpen] = useState(false);
//   const [rect, setRect] = useState(null);

//   const updateRect = () => {
//     if (anchorRef.current) setRect(anchorRef.current.getBoundingClientRect());
//   };

//   return (
//     <div
//       ref={anchorRef}
//       className="relative"
//       onMouseEnter={() => {
//         updateRect();
//         setOpen(true);
//       }}
//       onMouseLeave={() => setOpen(false)}
//       onMouseMove={() => updateRect()}
//     >
//       <div
//         className={
//           "w-40 rounded-2xl border p-3 text-center shadow-sm transition " +
//           (isOriginator
//             ? "bg-white border-[var(--button-border-color)]"
//             : isSkipped
//             ? "bg-slate-50 border-[var(--button-border-color)] opacity-60"
//             : "bg-white border-[var(--button-border-color)]")
//         }
//       >
//         <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--background-grey)] text-white shadow">
//           {isOriginator ? <UserRoundCog size={30} /> : <UsersRound size={30} />}
//         </div>
//         <div className="text-[13px] font-semibold text-slate-900">{title}</div>
//         <div className="mt-0.5 text-[11px] text-slate-500">{subtitle || "—"}</div>
//       </div>

//       {tooltip ? (
//         <TooltipPortal anchorRect={rect} open={open}>
//           <div className="space-y-1 text-sm">{tooltip}</div>
//         </TooltipPortal>
//       ) : null}
//     </div>
//   );
// };

// /* ------------------ main preview ------------------ */
// export function FlowPreviewRender({ data }) {
//   const originators = data.originators || [];
//   const stages = data.approvalStages || [];
//   const isAutoApprovedWhenNoStages = stages.length === 0;

//   return (
//     <div className="w-full rounded-2xl border border-[var(--button-border-color)] shadow-sm p-5">
//       <div className="mb-4 flex items-center justify-between">
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             {titleCase(data.flow_name || "Approval Flow Preview")}
//           </h2>
//           <p className="text-sm text-[var(--description-color)] mt-2">
//             {titleCase(data.documentCategory || "")} / {titleCase(data.documentType || "")}
//           </p>
//         </div>
//         <Pill className={data.is_active ? "text-[var(--success-color)]" : "text-[var(--error-color)]"}>
//           <ShieldCheck size={15} /> {data.is_active ? "Active" : "Inactive"}
//         </Pill>
//       </div>

//       {/* Render each originator as its own flow line */}
//       {originators.map((o, idx) => {
//         const { title, subtitle } = originatorDisplay(o);
//         return (
//           <div key={idx} className="flex items-center max-w-full overflow-x-auto mb-6">
//             <StageNode
//               title={title}
//               subtitle={subtitle}
//               variant="originator"
//               tooltip={
//                 <>
//                   <div>
//                     <span className="font-semibold opacity-60">Department:</span>{" "}
//                     {o.departmentObj?.label || "—"}
//                   </div>
//                   <div>
//                     <span className="font-semibold opacity-60">Role:</span>{" "}
//                     {o.roleObj?.label || "—"}
//                   </div>
//                   <div>
//                     <span className="font-semibold opacity-60">Users:</span>{" "}
//                     {usersToNames(o.user_names)}
//                   </div>
//                 </>
//               }
//             />

//             {stages.map((s, i) => (
//               <React.Fragment key={i}>
//                 <Connector />
//                 <StageNode
//                   title={stageTitle(i)}
//                   subtitle={getRoleLabel(s.role_name)}
//                   tooltip={
//                     <>
//                       <div>
//                         <span className="font-semibold opacity-60">Role:</span> {s.role_name}
//                       </div>
//                       <div>
//                         <span className="font-semibold opacity-60">Users:</span> {usersToNames(s.users)}
//                       </div>
//                       <div>
//                         <span className="font-semibold opacity-60">Timeline:</span>{" "}
//                         {getTimelineLabel(s.timeline)}
//                       </div>
//                       <div>
//                         <span className="font-semibold opacity-60">Actions:</span>{" "}
//                         {actionsToList(s.actions).join(", ") || "—"}
//                       </div>
//                     </>
//                   }
//                 />
//               </React.Fragment>
//             ))}
//           </div>
//         );
//       })}

//       <div className="mt-4 rounded-xl border border-[#E5E7EB] bg-[#E5E7EB] p-5 text-sm text-slate-700">
//         <div className="flex items-start gap-2">
//           <Info className="mt-0.5" size={20} fill="#374151" stroke="#fff" />
//           <div>
//             <div className="font-medium text-[#1F2937]">Auto-Approval Notice</div>
//             <div className="text-[#374151]">
//               {isAutoApprovedWhenNoStages
//                 ? "Auto-approved when originator is the last stage."
//                 : "Auto-approved when originator is last stage and no pending approval remains."}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function FlowPreview() {
//   const { values } = useFormikContext();
//   return (
//     <div className="max-w-full overflow-auto w-full">
//       <FlowPreviewRender data={values} />
//     </div>
//   );
// }
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useFormikContext } from "formik";
import {
  UserRoundCog,
  UsersRound,
  Info,
  ShieldCheck,
  Clock,
  ChevronRight,
} from "lucide-react";

/* ------------------ utils ------------------ */
const titleCase = (s = "") => {
  if (s && typeof s === "object") s = s.label || s.value || "";
  if (typeof s !== "string") return "";
  return s
    .replace(/[_-]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

const stageTitle = (idx) => `Stage ${idx + 1}`;

const timelineLabelMap = {
  lt_3_days: "< 3 Days",
  within_week: "< 7 Days",
  within_10_days: "< 10 Days",
};

const getTimelineLabel = (v) => {
  if (!v) return "—";
  if (typeof v === "object") v = v.label || v.value;
  return timelineLabelMap[v] || titleCase(v);
};

const actionNames = {
  approve: "Approve",
  reject: "Reject",
  rollback: "Rollback",
  edit: "Edit",
};

const actionsToList = (a = {}) =>
  Object.entries(a)
    .filter(([_, on]) => !!on)
    .map(([k]) => actionNames[k]);

const usersToNames = (users) =>
  (users && users.length ? users.map((u) => titleCase(u)).join(", ") : "—");

const getRoleLabel = (role) => {
  if (!role) return "—";
  if (typeof role === "object") return role.label || titleCase(role.value);
  return titleCase(role);
};

const originatorDisplay = (o) => {
  if (!o) return { title: "Originator", subtitle: "—" };
  const dept = titleCase(o.departmentObj?.label);
  const role = titleCase(o.roleObj?.label);
  const subtitle = [dept, role].filter(Boolean).join(" / ");
  return { title: "Originator", subtitle: subtitle || "Originator" };
};

const Connector = () => (
  <div
    className="mx-2 flex-1 h-[1px] border border-[var(--button-border-color)] min-w-10"
    aria-hidden
  />
);

const Pill = ({ children, className }) => (
  <span
    className={
      "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium " +
      (className || "bg-slate-100 text-slate-700")
    }
  >
    {children}
  </span>
);

/* ------------------ Safe Tooltip (Portal + clamp) ------------------ */
function TooltipPortal({ anchorRect, open, children, offset = 10, margin = 12 }) {
  const tooltipRef = useRef(null);
  const [style, setStyle] = useState({ display: "none" });

  const recompute = () => {
    if (!open || !anchorRect || !tooltipRef.current) {
      setStyle({ display: "none" });
      return;
    }

    const vw = window.innerWidth;
    const tw = tooltipRef.current.offsetWidth;

    const top = Math.max(0, anchorRect.bottom + offset);
    const anchorCenterX = anchorRect.left + anchorRect.width / 2;

    const clampedLeft = Math.min(
      Math.max(anchorCenterX - tw / 2, margin),
      Math.max(margin, vw - margin - tw)
    );

    setStyle({
      position: "fixed",
      top,
      left: clampedLeft,
      zIndex: 9999,
      display: "block",
      maxWidth: `min(${vw - margin * 2}px, 420px)`,
    });
  };

  useLayoutEffect(() => {
    recompute();
  }, [open, anchorRect]);

  useEffect(() => {
    if (!open) return;
    const onScroll = () => recompute();
    const onResize = () => recompute();
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", onResize);
    const id = requestAnimationFrame(recompute);
    return () => {
      cancelAnimationFrame(id);
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", onResize);
      cancelAnimationFrame(id);
    };
  }, [open, anchorRect]);

  if (!open) return null;

  return createPortal(
    <div ref={tooltipRef} style={style} className="pointer-events-none">
      <div className="relative">
        <div className="rounded-xl bg-[var(--background-grey)] p-4 text-white shadow-2xl ring-1 ring-black/10">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}

/* ------------------ Stage Node ------------------ */
const StageNode = ({ title, subtitle, tooltip, variant = "approver" }) => {
  const isOriginator = variant === "originator";
  const isSkipped = variant === "skipped";

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState(null);

  const updateRect = () => {
    if (anchorRef.current) {
      setRect(anchorRef.current.getBoundingClientRect());
    }
  };

  return (
    <div
      ref={anchorRef}
      className="relative"
      onMouseEnter={() => {
        updateRect();
        setOpen(true);
      }}
      onMouseLeave={() => setOpen(false)}
      onMouseMove={() => updateRect()}
    >
      <div
        className={
          "w-40 rounded-2xl border p-3 text-center shadow-sm transition " +
          (isOriginator
            ? "bg-white border-[var(--button-border-color)]"
            : isSkipped
            ? "bg-slate-50 border-[var(--button-border-color)] opacity-60"
            : "bg-white border-[var(--button-border-color)]")
        }
      >
        <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--background-grey)] text-white shadow">
          {isOriginator ? <UserRoundCog size={30} /> : <UsersRound size={30} />}
        </div>
        <div className="text-[13px] font-semibold text-slate-900">{title}</div>
        <div className="mt-0.5 text-[11px] text-slate-500">{subtitle || "—"}</div>
      </div>

      {tooltip ? (
        <TooltipPortal anchorRect={rect} open={open}>
          <div className="space-y-1 text-sm">{tooltip}</div>
        </TooltipPortal>
      ) : null}
    </div>
  );
};

/* ------------------ main preview ------------------ */
export function FlowPreviewRender({ data }) {
  const originators = data.originators || [];
  const stages = data.approvalStages || [];
  const isAutoApprovedWhenNoStages = stages.length === 0;

  return (
    <div className="w-full rounded-2xl border border-[var(--button-border-color)] shadow-sm p-5">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            {titleCase(data.flow_name || "Approval Flow Preview")}
          </h2>
          <p className="text-sm text-[var(--description-color)] mt-2">
            {[data.documentCategory, data.documentType]
              .filter(Boolean)
              .map(titleCase)
              .join(" / ")}
          </p>
        </div>
        <Pill className={data.is_active ? "text-[var(--success-color)]" : "text-[var(--error-color)]"}>
          <ShieldCheck size={15} /> {data.is_active ? "Active" : "Inactive"}
        </Pill>
      </div>

      {/* Render each originator as its own flow line */}
      {originators.map((o, idx) => {
        const { title, subtitle } = originatorDisplay(o);
        return (
          <div key={idx} className="flex items-center max-w-full overflow-x-auto mb-6">
            <StageNode
              title={title}
              subtitle={subtitle}
              variant="originator"
              tooltip={
                <>
                  <div>
                    <span className="font-semibold opacity-60">Department:</span>{" "}
                    {o.departmentObj?.label || "—"}
                  </div>
                  <div>
                    <span className="font-semibold opacity-60">Role:</span>{" "}
                    {o.roleObj?.label || "—"}
                  </div>
                  <div>
                    <span className="font-semibold opacity-60">Users:</span>{" "}
                    {usersToNames(o.user_names)}
                  </div>
                </>
              }
            />

            {stages.map((s, i) => (
              <React.Fragment key={i}>
                <Connector />
                <StageNode
                  title={stageTitle(i)}
                  subtitle={getRoleLabel(s.role_name)}
                  tooltip={
                    <>
                      <div>
                        <span className="font-semibold opacity-60">Role:</span> {s.role_name}
                      </div>
                      <div>
                        <span className="font-semibold opacity-60">Users:</span> {usersToNames(s.users)}
                      </div>
                      <div>
                        <span className="font-semibold opacity-60">Timeline:</span>{" "}
                        {getTimelineLabel(s.timeline)}
                      </div>
                      <div>
                        <span className="font-semibold opacity-60">Actions:</span>{" "}
                        {actionsToList(s.actions).join(", ") || "—"}
                      </div>
                    </>
                  }
                />
              </React.Fragment>
            ))}
          </div>
        );
      })}

      <div className="mt-4 rounded-xl border border-[#E5E7EB] bg-[#E5E7EB] p-5 text-sm text-slate-700">
        <div className="flex items-start gap-2">
          <Info className="mt-0.5" size={20} fill="#374151" stroke="#fff" />
          <div>
            <div className="font-medium text-[#1F2937]">Auto-Approval Notice</div>
            <div className="text-[#374151]">
              {isAutoApprovedWhenNoStages
                ? "Auto-approved when originator is the last stage."
                : "Auto-approved when originator is last stage and no pending approval remains."}
            </div>
          </div>
        </div>
      </div>

      {/* Legend */}
      <div className="mt-6">
        <div className="text-sm font-medium text-slate-700 mb-2">Legend</div>
        <div className="flex flex-wrap items-center gap-6 text-sm">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--background-grey)] text-white">
              <UserRoundCog size={14} />
            </span>{" "}
            Originator
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--background-grey)] text-white">
              <UsersRound size={14} />
            </span>{" "}
            Approver
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[var(--background-grey)] text-white opacity-60">
              <UsersRound size={14} />
            </span>{" "}
            Skipped Stage
          </div>
        </div>
      </div>
    </div>
  );
}

export default function FlowPreview() {
  const { values } = useFormikContext();
  return (
    <div className="max-w-full overflow-auto w-full">
      <FlowPreviewRender data={values} />
    </div>
  );
}
